/* tslint:disable */
/* eslint-disable */
/**
 * True one Services API
 * True one service for form Builder
 *
 * The version of the OpenAPI document: 4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RollbackRequest
 */
export interface RollbackRequest {
    /**
     * 
     */
    versionId?: string;
}

/**
 * Check if a given object implements the RollbackRequest interface.
 */
export function instanceOfRollbackRequest(value: object): value is RollbackRequest {
    return true;
}

export function RollbackRequestFromJSON(json: any): RollbackRequest {
    return RollbackRequestFromJSONTyped(json, false);
}

export function RollbackRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RollbackRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'versionId': json['versionId'] == null ? undefined : json['versionId'],
    };
}

export function RollbackRequestToJSON(json: any): RollbackRequest {
    return RollbackRequestToJSONTyped(json, false);
}

export function RollbackRequestToJSONTyped(value?: RollbackRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'versionId': value['versionId'],
    };
}

